<template>
    <div class="page">
        <div class="ytop">
            <div class="title">
                <!-- <img src="@/assets/img/she/aw_L.png" alt="" @click="backPage"> -->
                <div class="c-data">设备管理</div>
            </div>
            <div class="logo">
                <img src="@/assets/kairan.jpg">
                <div class="user-name">
                    <div class="name">{{ recordLoginText }}</div>
                    <div class="time">到期时间:{{ dataForm.expireTime }}</div>
                </div>
            </div>
            <div class="top-content">
                <div class="used">
                    <div class="used-total-num">{{ dataForm.totalData }}<span>GB</span></div>
                    <div class="used-total-CN">当前套餐总量</div>
                </div>
                <div class="used">
                    <div class="used-total-num">{{ dataForm.useDay }}<span>天</span></div>
                    <div class="used-total-CN">使用时长</div>
                </div>
                <div class="used">
                    <div class="used-total-num">{{ dataForm.remainDay }}<span>天</span></div>
                    <div class="used-total-CN">剩余时长</div>
                </div>
            </div>
        </div>
        <div class="device">
            <div class="today">
                <img src="@/assets/img/she/icon_jrll.png" alt="">
                <div class="wifi">套餐用量</div>
                <div class="wifi-gb">{{ dataForm.useData }}<span>GB</span></div>
            </div>
            <div class="today">
                <img src="@/assets/img/she/icon_rdlj.png" alt="">
                <div class="wifi">热点连接</div>
                <div class="wifi-gb" style="color:#FF913B;">{{ dataForm.deviceConnNum }}<span>设备</span></div>
            </div>
            <!-- deviceStatus 0 离线  1在线 -->
            <div class="device-state device-bg" v-if="dataForm.deviceStatus === '0'">设备已离线</div>
            <div class="device-state device-bg1" v-if="dataForm.deviceStatus === '1'">设备在线</div>
            <div class="quantity">
              <div class="quantity-i">
                  <img v-if="battery *1 === 0" src="@/assets/img/she/5.png" alt="">
                  <img v-if="battery*1>0 && battery*1<26" src="@/assets/img/she/6.png" alt="">
                  <img v-if="battery*1>25 && battery*1<51" src="@/assets/img/she/7.png" alt="">
                  <img v-if="battery*1>50 && battery*1<100" src="@/assets/img/she/8.png" alt="">
                  <img v-if="battery*1 === 100" src="@/assets/img/she/9.png" alt="">
              </div>
              剩余电量 
              <div class="quantity-n" v-if="battery*1 === 0" style="padding-left:6px;"> {{battery}}%</div>
              <div class="quantity-n" v-if="battery*1>0 && battery*1<26" style="color:#e62307;padding-left:6px;">{{battery}}%</div>
              <div class="quantity-n" v-if="battery*1>25 && battery*1<51" style="color:#FF8040;padding-left:6px;"> {{battery}}%</div>
              <div class="quantity-n" v-if="battery*1>50 && battery*1<100" style="color:#43CF7C;padding-left:6px;"> {{battery}}%</div>
              <div class="quantity-n" v-if="battery*1 === 100" style="color:#43CF7C;padding-left:6px;"> {{battery}}%</div>
  
          </div>
          <div class="quantity">
              <div class="quantity-i">
                  <img  src="@/assets/img/she/10.png" alt="">
              </div>
              信号强度 
              <div class="quantity-n" style="color:#43CF7C;padding-left:6px;"> {{rssi}} dBm</div>
          </div>
        </div>
        <div class="content-edit1">
            <!-- <div class="title-flex" style="margin-top:24px;">
                <div class="big">套餐充值</div>
            </div>
            <div class="btn22" style="padding-top:12px;">
                <div class="b1" @click="toHome()">
                    查询 / 充值套餐
                </div>

            </div>

            <br/>
            <br/> -->
            <div class="title-flex">
                <div class="big">修改密码</div>
                <div class="big-btn" @click="sureUpdatePass()">确认修改</div>
            </div>
            <div class="form-flex">
                <div class="label">热点名称:</div>
                <input class="value" placeholder="热点名称" v-model="dataForm.wifiName" />
            </div>
            <div class="form-flex">
                <div class="label">WIFI密码:</div>
                <input class="value" placeholder="WIFI密码" v-model="dataForm.wifiPwd" />
            </div>

            <div class="title-flex" style="margin-top:24px;">
                <div class="big">网络优选</div>
            </div>

            <div  class="operator" @click="radioChange('1')" :class="[radio === '1' ? 'is-active' : '']" v-if="this.dataForm.sysMap.inIccid1&&this.dataForm.sysMap.inIccid1.length>2">
                <img src="@/assets/img/she/icon_zgdx.png" alt="">
                <div class="operator-name">中国电信 ({{ in1AuthName }})</div>
                <div class="operator-state" v-if="radio === '1'">正在使用</div>
            </div>

            <div class="operator" @click="radioChange('2')" :class="[radio === '2' ? 'is-active' : '']"  v-if="this.dataForm.sysMap.inIccid2&&this.dataForm.sysMap.inIccid2.length>2">
                <img src="@/assets/img/she/icon_zglt.png" alt="">
                <div class="operator-name">中国联通 ({{ in2AuthName }})</div>
                <div class="operator-state" v-if="radio === '2'">正在使用</div>
            </div>

            <div class="operator" @click="radioChange('0')" :class="[radio === '0' ? 'is-active' : '']" v-if="this.dataForm.sysMap.outIccid&&this.dataForm.sysMap.outIccid.length>2">
              <img src="@/assets/img/she/icon_zgyd.png" alt="">
              <div class="operator-name">中国移动  ({{ outAuthName }})</div>
              <div class="operator-state" v-if="radio === '0'">正在使用</div>
          </div>


            <div class="title-flex" style="margin-top:24px;">
                <div class="big">认证设备号：{{ recordLoginText }}</div>
            </div>
            <div class="btn22" style="padding-top:12px;">
                <div class="b1" @click="toCtccUrl()" v-if="this.dataForm.sysMap.inIccid1&&this.dataForm.sysMap.inIccid1.length>2">
                    <img src="@/assets/img/she/icon_zgdx.png" alt="">
                    电信实名
                </div>
                <div class="b1" @click="toCuccUrl()"  v-if="this.dataForm.sysMap.inIccid2&&this.dataForm.sysMap.inIccid2.length>2">
                    <img src="@/assets/img/she/icon_zglt.png" alt="">
                    联通实名
                </div>
                <div class="b1" @click="toCmccAuth()" v-if="this.dataForm.sysMap.outIccid&&this.dataForm.sysMap.outIccid.length>2">
                    <img src="@/assets/img/she/icon_zgyd.png" alt="">
                    移动实名
                </div>

            </div>



        </div>



        <div class="footer-hi">温馨提示:</div>
        <div class="xsdw">1.修改设备后，页面数据将会有30分钟左右得延迟，并不影响您得使用。</div>
        <div class="xsdw">2.修改密码和切换网络后，需要等待30分钟重新把设备通电即可修改成功。</div>
        <div class="xsdw" style="padding-bottom:30px;">3.任何不懂可联系我们在线客服。</div>

        <van-dialog v-model="show" title="温馨提示" @confirm="confirm" @cancel="cancel" show-cancel-button
            confirmButtonText="确定切换" cancelButtonText="取消切换" confirmButtonColor="#333" cancelButtonColor="#9e9e9e">
            <div class="el-tip">
                <div>1.切换网络前需要先实名切换的卡板，否则将会导致停机</div>
                <div>2.切换成功后，设备将会在30分钟后完成切换，请耐心等待</div>
                <div>3.信号灯绿色常亮表示切换完毕，如有其它疑问，可联系客服处理</div>
                <div>4.切换成功之后，系统将会自动退出 需要重新登录。</div>
                <!-- <van-checkbox v-model="checked" shape="square">这张卡网速太慢，我要换卡使用</van-checkbox> -->
            </div>
        </van-dialog>


    </div>
</template>
<script>
import { wxRequest } from "@/api/user";
import { Dialog } from "vant";
export default {
    data() {
        return {
            outAuthName: '',
            in1AuthName: '',
            in2AuthName: '',
            recordLoginText: localStorage.getItem("recordLoginText"),
            dataForm: {},
            show: false,
            wxHeadImg: localStorage.getItem("wxHeadImg"),
            radio: '',
            radioCopy: "",
            battery: '',
            rssi:'',
            iccid: localStorage.getItem("iccid"),
        }
    },
    created() {
        this.init()
    },
    watch: {
        radio(val, old) {
            this.radioCopy = old
        }
    },
    methods: {
        toCmccAuth() {
            wxRequest(
                "wxAuth/cmcc/auth",
                { iccid: this.dataForm.sysMap.outIccid,isCheckout:"1s" },
                "post"
            ).then((res) => {
                if (res.data.code == "200") {
                    window.location.href = res.data.data;
                } else {
                    Dialog.alert({
                        title: "提示",
                        message: res.data.message,
                    });
                }
            });
        },
        toHome() {
            if (localStorage.getItem('isNewPage') == 0) {
                this.$router.replace('/user/home');
            } else if (localStorage.getItem('isNewPage') == 1) {
                this.$router.replace('/userNew/home');
            } else if (localStorage.getItem('isNewPage') == 2) {
                this.$router.replace('/user/homeNew');
            } else if (localStorage.getItem('isNewPage') == 3) {
                this.$router.replace('/new/home');
            } else {
                this.$router.replace('/user/home');
            }
        },
        toCuccUrl() {
            if (this.in2AuthName == '已实名') {
                Dialog.alert({
                    title: "提示",
                    message: '已实名，无需重复操作！',
                });
                return;
            }
            window.location.href = 'http://wx.yunzhineng.top/#/user/cuccAuthUrl?iccid=' + this.dataForm.sysMap.inIccid2;
        },
        toCtccUrl() {
            if (this.in1AuthName == '已实名') {
                Dialog.alert({
                    title: "提示",
                    message: '已实名，无需重复操作！',
                });
                return;
            }
            wxRequest(
                "wxAuth/ctcc/to/5G/auth",
                { iccid: this.dataForm.sysMap.inIccid1, isCheckout: "sa" },
                "post"
            ).then((res) => {
                if (res.data.code == "200") {
                    window.location.href = res.data.data;
                } else {
                    Dialog.alert({
                        title: "提示",
                        message: res.data.message,
                    });
                }
            });
        },
        sureUpdatePass() {
            var data = {
                wifiName: this.dataForm.wifiName,
                wifiPwd: this.dataForm.wifiPwd,
                iccid: this.iccid
            }
            wxRequest("sim/update/shebei/pwd", data, "post").then(res => {
                if (res.data.code === '200') {
                    Dialog.alert({
                        title: '修改成功',
                        message: res.data.message
                    })

                } else {
                    Dialog.alert({
                        title: '温馨提示',
                        message: res.data.message
                    })
                }
            })
        },
        init() {
            var data = {
                iccid: this.iccid
            }
            wxRequest("sim/get/shebei/info", data, "post").then(res => {
                if (res.data.code === '200') {
                    this.dataForm = res.data.data
                    this.radio = String(res.data.data.netState)
                    this.outAuthName = res.data.data.sysMap.outAuthName;
                    this.in1AuthName = res.data.data.sysMap.in1AuthName;
                    this.in2AuthName = res.data.data.sysMap.in2AuthName;
                    this.battery = res.data.data.sysMap.battery;
                    this.rssi = res.data.data.sysMap.rssi;
                } else {
                    Dialog.alert({
                        title: '温馨提示',
                        message: res.data.message
                    })
                }
            })
        },
        radioChange(e) {
            this.radio = e
            this.show = true
        },
        cancel() {
            this.radio = this.radioCopy
            this.show = false
        },
        confirm() {
            if (this.radio == 1 && this.in1AuthName == '未实名') {
                Dialog.alert({
                    title: '实名提示',
                    message: '请先完成实名后再来进行切换操作，如已实名 请耐心等待5-10分钟完成实名同步'
                })
                return;
            }
            if (this.radio == 2 && this.in2AuthName == '未实名') {
                Dialog.alert({
                    title: '实名提示',
                    message: '请先完成实名后再来进行切换操作，如已实名 请耐心等待5-10分钟完成实名同步'
                })
                return;
            }
            if (this.radio == 0 && this.outAuthName == '未实名') {
                Dialog.alert({
                    title: '实名提示',
                    message: '请先完成实名后再来进行切换操作，如已实名 请耐心等待5-10分钟完成实名同步'
                })
                return;
            }
            var data = {
                iccid: this.iccid
            }
            if (this.radio == 1) {
                data.cardSlot = this.dataForm.sysMap.in1Num
                data.newIccid = this.dataForm.sysMap.inIccid1
            } else if (this.radio == 2) {
                data.cardSlot = this.dataForm.sysMap.in2Num
                data.newIccid = this.dataForm.sysMap.inIccid2
            }else if (this.radio == 0) {
                data.cardSlot = this.dataForm.sysMap.outNum
                data.newIccid = this.dataForm.sysMap.outIccid
            }
            wxRequest("sim/update/shebei/qie", data, "post").then(res => {
                if (res.data.code === '200') {
                    Dialog.alert({
                        title: '切换成功',
                        message: res.data.message
                    })
                    localStorage.setItem("iccid", data.newIccid);
                    this.$store.state.iccid = data.newIccid;
                    //this.$router.push({ path: '/userNew/logins', query: {  } })
                } else {
                    Dialog.alert({
                        title: '温馨提示',
                        message: res.data.message
                    })
                }
            })
        },
        backPage() {
            let _this = this;
            if (_this.$store.state.isNewPage == 1 || localStorage.getItem('isNewPage') == 1) {
                _this.$router
                    .push({
                        path: "/userNew/home",
                        query: {
                            iccid: _this.$store.state.iccid,
                        },
                    })
                    .catch(() => { });
            } else {
                _this.$router
                    .push({
                        path: "/user/home",
                        query: {
                            iccid: _this.$store.state.iccid,
                        },
                    })
                    .catch(() => { });
            }
        }
    }
}
</script>

<style lang="less" scoped>
.page {
    // height: 100vh;
    background: #F5F6F7;

    .ytop {
        height: 260px;
        background: url('../../assets/img/she/bg_sbgl.png')no-repeat top center;
        background-size: 100% 100%;

        .title {
            display: flex;
            height: 40px;
            align-items: center;

            .img {
                width: 25px;
                height: 25px;
                margin-left: 7px;
            }

            .c-data {
                text-align: center;
                color: #fff;
                font-size: 18px;
                width: calc(100% - 32px);
                font-weight: bold;
            }
        }

        .logo {
            margin-top: 18px;
            display: flex;
            align-items: center;

            img {
                width: 65px;
                height: 65px;
                border-radius: 100%;
                margin-left: 14px;
                margin-right: 14px;
            }

            .user-name {
                width: calc(100% - 93px);
                color: #fff;

                .name {
                    font-size: 18px;
                    margin-bottom: 12px
                }

                .time {
                    font-size: 13px;
                }
            }
        }

        .top-content {
            height: 96px;
            border-radius: 10px;
            background: #fff;
            display: flex;
            width: 90%;
            margin: 0 auto;
            align-items: center;
            justify-content: space-around;
            margin-top: 18px;

            .used {
                text-align: center;

                .used-total-num {
                    font-size: 24px;
                    margin-bottom: 14px;
                    font-weight: bold;

                    span {
                        font-size: 13px;
                        font-weight: normal;
                    }
                }

                .used-total-CN {
                    font-size: 13px;
                }
            }
        }
    }

    .device {
        margin: 0 auto;
        background: #fff;
        width: 90%;
        border-radius: 10px;
        position: relative;

        .today {
            display: flex;
            padding: 15px;
            align-items: center;

            &:nth-child(2) {
                padding-top: 0;
            }

            .wifi {
                font-size: 14px;
                padding-left: 7px;
                padding-right: 12px;
            }

            .wifi-gb {
                font-size: 20px;
                color: #FF533B;
                font-weight: bold;

                span {
                    color: #000;
                    font-size: 14px;
                    font-weight: normal;
                    padding-left: 6px;
                }
            }
        }

        .device-state {
            font-size: 12px;
            position: absolute;
            right: 0;
            width: 80px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            top: 32px;
        }

        .device-bg {
            color: #888888;
            background: url('../../assets/img/she/bg_lx.png') no-repeat center;
            background-size: 100% 100%;
        }

        .device-bg1 {
            color: #3EC230;
            background: url('../../assets/img/she/bg_lx1.png') no-repeat center;
            background-size: 100% 100%;
        }
    }

    .quantity {
        background: #fff;
        padding: 0 18px;
        display: flex;
        align-items: center;

        img {
            width: 28px;
            height: 28px;
            margin-right: 20px;
        }
    }

    .content-edit1 {
        width: 90%;
        // height: 329px;
        margin: 15px auto;
        background: #fff;
        padding: 18px 0;
        border-radius: 10px;

        .title-flex {
            display: flex;
            padding: 0 15px;
            justify-content: space-between;

            .big {
                font-size: 16px;
                font-weight: 500;
                position: relative;
                margin-left: 10px;

                &::before {
                    content: '';
                    height: 15px;
                    left: -10px;
                    width: 3px;
                    background: #FF4C37;
                    border-radius: 2px;
                    position: absolute;

                }
            }

            .big-btn {
                background: url('../../assets/img/she/bt_qrxg.png') no-repeat center;
                background-size: 100% 100%;
                width: 70px;
                height: 25px;
                text-align: center;
                font-size: 13px;
                color: #fff;
                line-height: 24px;
            }
        }

        .btn22 {
            justify-content: center;
            display: flex;
            width: 85%;
            align-items: center;
            margin: 0 auto;

            div {
                text-align: center;
                line-height: 38px;
                flex: 1;
                border: 1px solid #f27c6a;
                border-radius: 20px;

                &:nth-child(1) {
                    margin-right: 20px;
                }

                img {
                    vertical-align: middle;
                }
            }
        }

        .form-flex {
            margin: 0 15px;
            background: #F5F6F7;
            height: 50px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            margin-top: 14px;

            .label {
                width: 30%;
                text-align: center;
                font-size: 15px;
                font-family: Source Han Sans CN;
            }

            .value {
                background: none;
                width: 70%;
                font-size: 15px;
            }
        }

        .operator {
            height: 55px;
            border-radius: 7px;
            border: 1px solid #FFFBFA;
            background: #F0E3E1;
            margin: 0 15px;
            margin-top: 14px;
            display: flex;
            position: relative;
            align-items: center;

            img {
                margin: 0 16px;
            }

            .operator-name {
                font-size: 16px;
                margin-right: 10px;
            }

            .operator-type {
                font-size: 12px;
                text-align: center;
                height: 16px;
                width: 50px;
                line-height: 16px;
                color: #fff;
            }

            .operator-type-seccess {
                background: url('../../assets/img/she/bg_ysm.png') no-repeat center;
                background-size: 100% 100%;
            }

            .operator-type-waring {
                background: url('../../assets/img/she/icon_wsm.png') no-repeat center;
                background-size: 100% 100%;
            }

            .operator-state {
                color: #FF533B;
                font-size: 12px;
                position: absolute;
                right: 12px;
            }
        }

        .is-active {
            background: url('../../assets/img/she/select.png') no-repeat center;
            background-size: 100% 100%;
        }
    }

    .footer-hi {
        font-size: 13px;
        color: #666;
        font-weight: 500;
        width: 90%;
        margin: 15px auto 12px auto;
    }

    .xsdw {
        color: #666;
        font-size: 12px;
        width: 90%;
        margin: 0 auto 12px auto;
        line-height: 20px;
    }
}

.el-tip {
    padding: 14px;
    line-height: 1.5;
    color: #333;
    font-size: 14px;
}
</style>

